import router from "@/router";
import nativeHandlerService from "@/services/nativeHandler";

export const goToMyTicketWithCoupon = (limitedExpressTicketId) => {
  if (process.env.NODE_ENV == "local") {
    router.push({
      name: "MfittMyTicket",
      params: { id: limitedExpressTicketId },
      query: { is_used_coupon: true },
    });
  } else {
    nativeHandlerService.openTicket(
      `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}mfitt/my-ticket/${limitedExpressTicketId}?is_used_coupon=true`
    );
  }
};
